function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.1998 21.7C25.1998 15.5144 20.1854 10.5 13.9998 10.5C7.81422 10.5 2.7998 15.5144 2.7998 21.7",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 16.7998C19.6 14.6998 16.8 13.2998 14 13.2998",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5999 10.4999V9.7999C12.5999 9.0267 13.2267 8.3999 13.9999 8.3999C14.7731 8.3999 15.3999 9.0267 15.3999 9.7999V10.4999",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9999 25.8997C20.9587 25.8997 26.5999 24.6461 26.5999 23.0997C26.5999 23.0997 26.5999 21.6997 25.1999 21.6997C25.1999 21.6997 19.5999 23.0997 13.9999 23.0997C8.3999 23.0997 2.7999 21.6997 2.7999 21.6997C1.3999 21.6997 1.3999 23.0997 1.3999 23.0997C1.3999 24.6461 7.04111 25.8997 13.9999 25.8997Z",
  stroke: "#151515",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.79971 2.7998L10.0903 3.2357C10.7621 4.2434 10.7621 5.55621 10.0903 6.56391L9.79971 6.9998",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9999 1.3999L14.2905 1.8358C14.9623 2.8435 14.9623 4.1563 14.2905 5.164L13.9999 5.5999",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1999 2.7998L18.4905 3.2357C19.1623 4.2434 19.1623 5.55621 18.4905 6.56391L18.1999 6.9998",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMainDish = function SvgMainDish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainDish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/main-dish.b4152c03.svg";
export { ForwardRef as ReactComponent };